<mat-toolbar class="main-header">
  <button mat-icon-button (click)="goBack()">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <span>Plantillas de email</span>
</mat-toolbar>

<block-ui>
  <div class="templates-page">
    @if (templates.length === 0 && !loading) {
      <div class="empty-state">
        <mat-icon class="empty-state__icon">mail_outline</mat-icon>
        <p class="empty-state__text">No hay plantillas disponibles.</p>
      </div>
    }

    @if (templates.length > 0) {
      <div class="templates-filters">
        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Buscar</mat-label>
          <input
            matInput
            [(ngModel)]="searchTerm"
            (ngModelChange)="applyFilter()"
            placeholder="Nombre, clave..."
          />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="filter-field filter-field--category"
        >
          <mat-label>Categoría</mat-label>
          <mat-select
            [(ngModel)]="selectedCategory"
            (ngModelChange)="applyFilter()"
          >
            <mat-option value="">Todas</mat-option>
            @for (cat of categories; track cat) {
              <mat-option [value]="cat">{{ cat }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="templates-list">
        @for (template of filteredTemplates; track template.key) {
          <mat-card
            class="template-card"
            (click)="editTemplate(template.key)"
            tabindex="0"
            role="button"
          >
            <div class="template-card__header">
              <div class="template-card__info">
                <span class="template-card__name">{{ template.name }}</span>
                <span class="template-card__key">{{ template.key }}</span>
              </div>
              <div class="template-card__badges">
                <span class="badge badge--category">{{
                  template.category
                }}</span>
                <span
                  class="badge"
                  [class.badge--enabled]="template.enabled"
                  [class.badge--disabled]="!template.enabled"
                >
                  {{ template.enabled ? "Activa" : "Inactiva" }}
                </span>
              </div>
            </div>
            @if (template.description) {
              <p class="template-card__desc">{{ template.description }}</p>
            }
            <div class="template-card__footer">
              <span class="template-card__version"
                >v{{ template.version }}</span
              >
              <mat-icon class="template-card__arrow">chevron_right</mat-icon>
            </div>
          </mat-card>
        }
      </div>
    }
  </div>
</block-ui>
